import React, { useState, useEffect } from "react";
import { Form } from "react-bootstrap";
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import { Link } from "react-router-dom";
import { getremoteInquirydataApi, getsingleprescription, getsinglebuildsheetData, getsinglestagestation, getsinglebuilstation, getsingleshipstagestation } from "../../Api/iron"
import { proscriptionhistory, getPrescription } from "../../Api/prescriptionApis"
import TabFormData from "../DashboardComponents/TabsData/TabFormData";
import TabNotesData from "../DashboardComponents/TabsData/TabNotesData";
import AccordionData from "../../DashboardPages/clubfittingupdate/AccordionData";
import { FaAngleUp, FaStar } from "react-icons/fa";
import { Accordion } from "react-bootstrap";
import PrescriptionLeft from "../Prescription/PrescriptionLeft";
import BuildAccordion from "./BuildAccordion";
import BuildSheetLeft from "./BuildSheetLeft";
import BuildStation from "./BuildStation";
import BuildStationLeft from "./BuildStationLeft";
import { getbuildsheet } from "../../Api/buildsheetApi"
const initData = {
    firstname: "",
    lastname: "",
    email: "",
    phone: "",
    height_ft: "",
    height_in: "",
    wrist_to_floor: "",
    shoulder_to_wrist: "",
    elbow_to_wrist: "",
    fitter_name: "",
};


const initialPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',
    optimalHeads: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalShafts: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    },
    optimalGrips: {
        option1: { make: '', model: '' },
        option2: { make: '', model: '' },
        option3: { make: '', model: '' }
    }
};

function BuildTabPrescription({ project_id, project_step = "history", currentpagename, buildsheets, ondeleteChange,remortFittingFormData ,SinglePrescription,prescriptiondatamobile,allmodels, allMakeData}) {

    const [validated, setValidated] = useState(false);
    const [historydata, setHistorydata] = useState([]);
    const [formData, setFormData] = useState(initData);
    const [prescription, setPrescription] = useState(0);
    const [buildsheetData, setBuildsheetData] = useState(0);

    const [current_project_step, setCurrent_project_step] = useState(project_step);
    const [prescriptiondata, setPrescriptiondata] = useState(initialPrescriptionState);

    const [buildsheetnumber, setBuildSheetNumber] = useState(0);

    // const [stageStation, setStageStation] = useState(0);
    // const [buildStation, setBuildStation] = useState(0);
    // const [shipStation, setShipStation] = useState(0);

    const getDataById = () => {
        // getremoteInquirydataApi({ id: project_id }).then((res) => {
        //     console.log("calling api", '2');
        //     if (res?.code === 200) {
        //         const userData = res.data.data;
        //         console.log("userData", userData);
        //         setFormData(userData);
        //         manageResult(userData.remotefittingdata);
        //     } else {
        //         alert(res.data?.message);
        //     }
        // }).catch((err) => {
        //     alert(err);
        // })
        if(remortFittingFormData){
            setFormData(remortFittingFormData);
            manageResult(remortFittingFormData.remotefittingdata);
        }
    }
    const [resultoutput, setResultoutput] = useState({
        white: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        black: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        blue: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        pink: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        purple: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        red: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        orange: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
        green: { iron1: 0, iron2: 0, iron3: 0, label: '', bestposition: 1 },
    });

    const manageResult = (result) => {
 
        const getwhitelabel = getLebel(result.step1);
        const getblacklabel = getLebel(result.step2);
        const getbluelabel = getLebel(result.step3);
        const getpinklabel = getLebel(result.step4);
        const getpurplelabel = getLebel(result.step5);
        const getredlabel = getLebel(result.step6);
        const getorangelabel = getLebel(result.step7);
        const getgreenlabel = getLebel(result.step8);
 
        setResultoutput({
            white: getwhitelabel,
            black: getblacklabel,
            blue: getbluelabel,
            pink: getpinklabel,
            purple: getpurplelabel,
            red: getredlabel,
            orange: getorangelabel,
            green: getgreenlabel,

        });
    }

    useEffect(() => {

    }, [resultoutput]);


    const getLebel = (step) => {

        var lowestIron = 0;
        var bestLabel = "";
        var bestposition = 1;
        const iron1_shot1 = parseInt(step.iron1.shot1.optionx_value) + parseInt(step.iron1.shot1.optiony_value) + parseInt(step.iron1.shot1.option1_value) + parseInt(step.iron1.shot1.option2_value);
        const iron1_shot2 = parseInt(step.iron1.shot2.optionx_value) + parseInt(step.iron1.shot2.optiony_value) + parseInt(step.iron1.shot2.option1_value) + parseInt(step.iron1.shot2.option2_value);
        const iron1_shot3 = parseInt(step.iron1.shot3.optionx_value) + parseInt(step.iron1.shot3.optiony_value) + parseInt(step.iron1.shot3.option1_value) + parseInt(step.iron1.shot3.option2_value);

        const iron2_shot1 = parseInt(step.iron2.shot1.optionx_value) + parseInt(step.iron2.shot1.optiony_value) + parseInt(step.iron2.shot1.option1_value) + parseInt(step.iron2.shot1.option2_value);
        const iron2_shot2 = parseInt(step.iron2.shot2.optionx_value) + parseInt(step.iron2.shot2.optiony_value) + parseInt(step.iron2.shot2.option1_value) + parseInt(step.iron2.shot2.option2_value);
        const iron2_shot3 = parseInt(step.iron2.shot3.optionx_value) + parseInt(step.iron2.shot3.optiony_value) + parseInt(step.iron2.shot3.option1_value) + parseInt(step.iron2.shot3.option2_value);

        const iron3_shot1 = parseInt(step.iron3.shot1.optionx_value) + parseInt(step.iron3.shot1.optiony_value) + parseInt(step.iron3.shot1.option1_value) + parseInt(step.iron3.shot1.option2_value);
        const iron3_shot2 = parseInt(step.iron3.shot2.optionx_value) + parseInt(step.iron3.shot2.optiony_value) + parseInt(step.iron3.shot2.option1_value) + parseInt(step.iron3.shot2.option2_value);
        const iron3_shot3 = parseInt(step.iron3.shot3.optionx_value) + parseInt(step.iron3.shot3.optiony_value) + parseInt(step.iron3.shot3.option1_value) + parseInt(step.iron3.shot3.option2_value);


        const iron1 = iron1_shot1 + iron1_shot2 + iron1_shot3;
        const iron2 = iron2_shot1 + iron2_shot2 + iron2_shot3;
        const iron3 = iron3_shot1 + iron3_shot2 + iron3_shot3;
        console.log("aminesh --- 2");

        if (iron1 <= iron2 && iron1 <= iron3) {
            lowestIron = 1;
        }
        else if (iron2 <= iron1 && iron2 <= iron3) {
            lowestIron = 2;
        }
        else if (iron3 <= iron1 && iron3 <= iron2) {
            lowestIron = 3;
        }
        else {
            lowestIron = 1;
        }


        if (step.name == "white Irons") {
            console.log("aminesh babu", iron1, iron2, iron3, lowestIron);
            if (lowestIron == 1) {
                bestLabel = "Low";
                bestposition = 1;
            } else if (lowestIron == 2) {
                bestLabel = "Mid";
                bestposition = 2;
            } else if (lowestIron == 3) {
                bestLabel = "High";
                bestposition = 3;
            }
        }

        if (step.name == "Black Irons") {
            if (lowestIron == 1) {
                bestLabel = "Upright";
                bestposition = 1;
            } else if (lowestIron == 2) {
                bestLabel = "Standard";
                bestposition = 2;
            } else if (lowestIron == 3) {
                bestLabel = "Flat";
                bestposition = 3;
            }
        }

        if (step.name == "Blue Irons") {
            console.log("white Irons lowestIron", iron1, iron2, iron3);
            if (lowestIron == 1) {
                bestLabel = "Heavy";
                bestposition = 1;
            } else if (lowestIron == 2) {
                bestLabel = "Medium";
                bestposition = 2;
            } else if (lowestIron == 3) {
                bestLabel = "Light";
                bestposition = 3;
            }
        }

        if (step.name == "Pink Irons") {
            if (lowestIron == 1) {
                bestLabel = "Hard";
                bestposition = 1;
            } else if (lowestIron == 2) {
                bestLabel = "Medium";
                bestposition = 2;
            } else if (lowestIron == 3) {
                bestLabel = "Soft";
                bestposition = 3;
            }
        }

        if (step.name == "Purple Irons") {
            if (lowestIron == 1) {
                bestLabel = "Firm Tip";
                bestposition = 1;
            } else if (lowestIron == 2) {
                bestLabel = "Soft Mid";
                bestposition = 2;
            } else if (lowestIron == 3) {
                bestLabel = "Firm Butt";
                bestposition = 3;
            }
        }

        if (step.name == "Red Irons") {
            if (lowestIron == 1) {
                bestLabel = "Oversize";
                bestposition = 1;
            } else if (lowestIron == 2) {
                bestLabel = "Mid";
                bestposition = 2;
            } else if (lowestIron == 3) {
                bestLabel = "Standard";
                bestposition = 3;
            }
        }

        if (step.name == "Orange Irons") {
            if (lowestIron == 1) {
                bestLabel = "Long";
                bestposition = 1;
            } else if (lowestIron == 2) {
                bestLabel = "Medium";
                bestposition = 2;
            } else if (lowestIron == 3) {
                bestLabel = "Short";
                bestposition = 3;
            }
        }

        if (step.name == "Green Irons") {
            if (lowestIron == 1) {
                bestLabel = "Heavy";
                bestposition = 1;
            } else if (lowestIron == 2) {
                bestLabel = "Medium";
                bestposition = 2;
            } else if (lowestIron == 3) {
                bestLabel = "Light";
                bestposition = 3;
            }
        }
        return { iron1: iron1, iron2: iron2, iron3: iron3, label: bestLabel, bestposition: bestposition };
    }
 

    const getbuildsheetscript = () => {
        getPrescription({ project_id: project_id }).then((res) => {
            console.log("calling api", "5");
            if (!res.data.status) {
                // setErrors(res.data.data);
            } else {
                setPrescriptiondata(res.data.data);
            }

        }).catch((error) => {
            console.log("error", error);
        });
    }

    console.log("current_project_step", current_project_step);
    const getData = () => {

        switch (current_project_step) {
            case "history":
                getDataById();
                getprescriptionDataById();
                getbuildsheetDataById();
                break;
            case "prescription":
                getDataById();
                getprescriptionDataById();
                getbuildsheetDataById();
                break;
            case "buildsheet":
                getbuildsheetscript();
                getbuildsheetDataById();
                break;
            case "stagestation":
                getDataById();
                getprescriptionDataById();
                getbuildsheetDataById();
                break;
            case "buildstation":
                getDataById();
                getprescriptionDataById();
                getbuildsheetDataById();
                break;
            case "shipstation":
                getDataById();
                getprescriptionDataById();
                getbuildsheetDataById();
                break;
            default:
                getDataById();
                getprescriptionDataById();
                getbuildsheetDataById();
                break;
        }
    }

    const getprescriptionDataById = () => {
        // getsingleprescription({ project_id: project_id }).then((res) => {
            
        //     if (res?.code === 200) {
        //         const prescriptionData = res.data.data;
        //         setPrescription(prescriptionData);
        //     } else {
        //         // alert(res.data?.message);
        //         console.log(res.data?.message);
        //     }
        // }).catch((err) => {
        //     alert(err);
        // })
        if(SinglePrescription){
            setPrescription(SinglePrescription);
        }
    }

    const getbuildsheetDataById = () => {
        getsinglebuildsheetData({ project_id: project_id }).then((res) => {
            // console.log("calling api", "2");
            if (res?.code === 200) {
                const buildsheetData = res.data.data;
                setBuildsheetData(buildsheetData);
            } else {
                console.log(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }

    useEffect(() => {
        getData();
        getbuildsheetData();
    }, [project_id])


    const [isTabVisible, setIsTabVisible] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth <= 991) {
                setIsTabVisible(true);
            } else {
                setIsTabVisible(false);
            }
        };

        // Set the initial state
        handleResize();

        // Add event listener for window resize
        window.addEventListener('resize', handleResize);

        // Cleanup event listener on component unmount
        return () => window.removeEventListener('resize', handleResize);
    }, []);


    const getbuildsheetData = () => {
        getbuildsheet({ id: project_id }).then((res) => {
            if (res?.code === 200) {
                const Data = res.data.data;
                setBuildSheetNumber(Data._id);
            } else {
                // alert(res.data?.message);
            }
        }).catch((err) => {
            alert(err);
        })
    }


    return (
        <>
            <div className="tab-container tab-club-fitting">
                <Tabs
                    defaultActiveKey="prescription"
                    id="uncontrolled-tab-example"
                    className="club-fitting-tab new_mobile_tab tab-wrapper"
                >
                    <Tab eventKey="prescription" title="Script">
                        <PrescriptionLeft project_id={project_id} disablestatus={buildsheetnumber} prescriptiondata={prescriptiondatamobile} allmodels={allmodels} allMakeData={allMakeData} />
                    </Tab>

                    {project_step === "prescription" ? (
                        <Tab eventKey="results" title="Results">
                            <div className="tab-box-section">
                                <div className="accordion-section">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0" className="results-accordion">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Bounce: <div className="light-text">{resultoutput.white.label}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.white.bestposition === 1 ? 'active' : ''}`}>White 1 <br /><span class="result-value">{resultoutput.white.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.white.bestposition === 2 ? 'active' : ''}`}>White 2 <br /><span class="result-value">{resultoutput.white.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.white.bestposition === 3 ? 'active' : ''}`}>White 3 <br /><span class="result-value">{resultoutput.white.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1" className="results-accordion black">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Lie Angle:  <div className="light-text">{resultoutput.black.label}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.black.bestposition === 1 ? 'active' : ''}`}>Black 1 <br /><span class="result-value">{resultoutput.black.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.black.bestposition === 2 ? 'active' : ''}`}>Black 2 <br /><span class="result-value">{resultoutput.black.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.black.bestposition === 3 ? 'active' : ''}`}>Black 3 <br /><span class="result-value">{resultoutput.black.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2" className="results-accordion blue">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Shaft Weight: <div className="light-text">{resultoutput.blue.label}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.blue.bestposition === 1 ? 'active' : ''}`}>Blue 1 <br /><span class="result-value">{resultoutput.blue.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.blue.bestposition === 2 ? 'active' : ''}`}>Blue 2 <br /><span class="result-value">{resultoutput.blue.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.blue.bestposition === 3 ? 'active' : ''}`}>Blue 3 <br /><span class="result-value">{resultoutput.blue.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="3" className="results-accordion pink">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Shaft Flex:  <div className="light-text">{resultoutput.pink.label}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.pink.bestposition === 1 ? 'active' : ''}`}>Pink 1 <br /><span class="result-value">{resultoutput.pink.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.pink.bestposition === 2 ? 'active' : ''}`}>Pink 2 <br /><span class="result-value">{resultoutput.pink.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.pink.bestposition === 3 ? 'active' : ''}`}>Pink 3 <br /><span class="result-value">{resultoutput.pink.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="4" className="results-accordion purple">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Shaft Profile:  <div className="light-text">{resultoutput.purple.label}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.purple.bestposition === 1 ? 'active' : ''}`}>Purple 1 <br /><span class="result-value">{resultoutput.purple.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.purple.bestposition === 2 ? 'active' : ''}`}>Purple 2 <br /><span class="result-value">{resultoutput.purple.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.purple.bestposition === 3 ? 'active' : ''}`}>Purple 3 <br /><span class="result-value">{resultoutput.purple.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="5" className="results-accordion red">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Grip Size:  <div className="light-text">{resultoutput.red.label}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.red.bestposition === 1 ? 'active' : ''}`}>Red 1 <br /><span class="result-value">{resultoutput.red.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.red.bestposition === 2 ? 'active' : ''}`}>Red 2 <br /><span class="result-value">{resultoutput.red.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.red.bestposition === 3 ? 'active' : ''}`}>Red 3 <br /><span class="result-value">{resultoutput.red.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="6" className="results-accordion orange">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Club Length:  <div className="light-text">{resultoutput.orange.label}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.orange.bestposition === 1 ? 'active' : ''}`}>Orange 1 <br /><span class="result-value">{resultoutput.orange.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.orange.bestposition === 2 ? 'active' : ''}`}>Orange 2 <br /><span class="result-value">{resultoutput.orange.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.orange.bestposition === 3 ? 'active' : ''}`}>Orange 3 <br /><span class="result-value">{resultoutput.orange.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="7" className="results-accordion green">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Swing Weight:  <div className="light-text">{resultoutput.green.label}</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <div className="irons-content">
                                                        <div className="result-club">
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.green.bestposition === 1 ? 'active' : ''}`}>Green 1 <br /><span class="result-value">{resultoutput.green.iron1}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item middle-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.green.bestposition === 2 ? 'active' : ''}`}>Green 2 <br /><span class="result-value">{resultoutput.green.iron2}</span></span>
                                                                </div>
                                                            </div>
                                                            <div className="result-club-item">
                                                                <div className="result-club-text">
                                                                    <span className={`result-title ${resultoutput.green.bestposition === 3 ? 'active' : ''}`}>Green 3 <br /><span class="result-value">{resultoutput.green.iron3}</span></span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                            </div>
                        </Tab>
                    ) : project_step === "buildsheet" ? (

                        <Tab eventKey="script" title="Script">
                            <div className="tab-box-section mb-4">
                                <div className="accordion-section">
                                    <Accordion defaultActiveKey="0">
                                        <Accordion.Item eventKey="0" className="results-accordion">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Bounce: <div className="light-text">Low</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <textarea className="dashboard-text-area" value={prescriptiondata.bounce} disabled rows="3" placeholder="Enter your script here"></textarea>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="1" className="results-accordion black">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Lie Angle:  <div className="light-text">Flat</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <textarea className="dashboard-text-area" value={prescriptiondata.lieage} disabled rows="3" placeholder="Enter your script here"></textarea>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="2" className="results-accordion blue">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Shaft Weight: <div className="light-text">Medium</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <textarea className="dashboard-text-area" rows="3" value={prescriptiondata.shaftweight} disabled placeholder="Enter your script here"></textarea>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="3" className="results-accordion pink">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Shaft Flex:  <div className="light-text">Soft Mid</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <textarea className="dashboard-text-area" rows="3" value={prescriptiondata.shaftflex} disabled placeholder="Enter your script here"></textarea>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="5" className="results-accordion red">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Grip Size:  <div className="light-text">Oversize</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <textarea className="dashboard-text-area" rows="3" value={prescriptiondata.gripSize} disabled placeholder="Enter your script here"></textarea>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="6" className="results-accordion orange">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Club Length:  <div className="light-text">Short</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <textarea className="dashboard-text-area" rows="3" value={prescriptiondata.clubLength} disabled placeholder="Enter your script here"></textarea>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                        <Accordion.Item eventKey="7" className="results-accordion green">
                                            <div className="gs_b p-0 club-fitting-card  accordion-item">
                                                <div className="accordion_card_view" id="lesson_card_1">
                                                    <Accordion.Header>
                                                        <div className="gab_title">
                                                            <div className="gab_text text-left">
                                                                <h5>
                                                                    <span className="color"></span>
                                                                    <div className="d-flex align-items-center gap-1">Swing Weight:  <div className="light-text">Light</div></div>
                                                                </h5>
                                                            </div>
                                                            <div className="collapsed">
                                                                <div className="gab_icon ">
                                                                    <FaAngleUp />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Accordion.Header>
                                                </div>
                                                <Accordion.Body className="results-accordion-body">
                                                    <textarea className="dashboard-text-area" rows="3" value={prescriptiondata.swingWeight} disabled placeholder="Enter your script here"></textarea>
                                                </Accordion.Body>
                                            </div>
                                        </Accordion.Item>
                                    </Accordion>
                                </div>
                            </div>
                            <div className="Optimal_Heads">
                                <div className="tab-box-section mb-4">
                                    <div className='blace_bg_box_head'>
                                        <div className="black_bg_box_title">
                                            Head 1
                                        </div>
                                        <div className={`black_star_box ${prescriptiondata?.optimalHeads?.option1?.make && prescriptiondata?.optimalHeads?.option1?.model ? 'active' : ''}`}>
                                            <FaStar />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalHeads?.option1?.make || ""} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Make</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                    <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalHeads?.option1?.modal || ""} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Modal</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                                <div className="tab-box-section mb-4">
                                    <div className='blace_bg_box_head'>
                                        <div className="black_bg_box_title">
                                            Head 2
                                        </div>
                                        <div className={`black_star_box ${prescriptiondata?.optimalHeads?.option2?.make && prescriptiondata?.optimalHeads?.option2?.modal ? 'active' : ''}`}>
                                            <FaStar />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalHeads?.option2?.make || ""} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Make</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                    <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalHeads?.option2?.modal || ""} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Modal</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                                <div className="tab-box-section mb-4">
                                    <div className='blace_bg_box_head'>
                                        <div className="black_bg_box_title">
                                            Head 3
                                        </div>
                                        <div className={`black_star_box ${prescriptiondata?.optimalHeads?.option3?.make && prescriptiondata?.optimalHeads?.option3?.modal ? 'active' : ''}`}>
                                            <FaStar />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalHeads?.option3?.make || ''} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Make</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                    <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalHeads?.option3?.modal || ''} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Modal</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                            </div>
                            <div className="Optimal_Shafts">
                                <div className="tab-box-section mb-4">
                                    <div className='blace_bg_box_head'>
                                        <div className="black_bg_box_title">
                                            Shafts 1
                                        </div>
                                        <div className={`black_star_box ${prescriptiondata?.optimalShafts?.option1?.make && prescriptiondata?.optimalShafts?.option1?.model ? 'active' : ''}`}>
                                            <FaStar />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalShafts?.option1?.make || ''} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Make</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                    <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalShafts?.option1?.model || ''} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Modal</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                                <div className="tab-box-section mb-4">
                                    <div className='blace_bg_box_head'>
                                        <div className="black_bg_box_title">
                                            Shafts 2
                                        </div>
                                        <div className={`black_star_box ${prescriptiondata?.optimalShafts?.option2?.make && prescriptiondata?.optimalShafts?.option2?.model ? 'active' : ''}`}>
                                            <FaStar />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalShafts?.option2?.make || ''} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Make</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                    <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalShafts?.option2?.model || ''} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Modal</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                                <div className="tab-box-section mb-4">
                                    <div className='blace_bg_box_head'>
                                        <div className="black_bg_box_title">
                                            Shafts 3
                                        </div>
                                        <div className={`black_star_box ${prescriptiondata?.optimalShafts?.option3?.make && prescriptiondata?.optimalShafts?.option3?.model ? 'active' : ''}`}>
                                            <FaStar />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalShafts?.option3?.make || ""} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Make</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                    <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalShafts?.option3?.model || ""} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Modal</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                            </div>
                            <div className="Optimal_Grips">
                                <div className="tab-box-section mb-4">
                                    <div className='blace_bg_box_head'>
                                        <div className="black_bg_box_title">
                                            Grips 1
                                        </div>
                                        <div className={`black_star_box ${prescription?.optimalGrips?.option1?.make && prescription?.optimalGrips?.option1?.model ? 'active' : ''}`}>
                                            <FaStar />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalGrips?.option1?.make || ''} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Make</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                    <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalGrips?.option1?.model || ''} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Modal</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                                <div className="tab-box-section mb-4">
                                    <div className='blace_bg_box_head'>
                                        <div className="black_bg_box_title">
                                            Grips 2
                                        </div>
                                        <div className={`black_star_box ${prescriptiondata?.optimalGrips?.option2?.make && prescriptiondata?.optimalGrips?.option2?.model ? 'active' : ''}`}>
                                            <FaStar />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalGrips?.option2?.make || ''} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Make</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                    <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalGrips?.option2?.model || ''} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Modal</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                                <div className="tab-box-section mb-4">
                                    <div className='blace_bg_box_head'>
                                        <div className="black_bg_box_title">
                                            Grips 3
                                        </div>
                                        <div className={`black_star_box ${prescriptiondata?.optimalGrips?.option3?.make && prescriptiondata?.optimalGrips?.option3?.model ? 'active' : ''}`}>
                                            <FaStar />
                                        </div>
                                    </div>
                                    <div className="col-12 col-md-12 form-group" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalGrips?.option3?.make} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Make</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                    <div className="col-12 col-md-12 form-group mb-0" controlid="validationCustom01">
                                        <select value={prescriptiondata?.optimalGrips?.option3?.model} disabled class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example">
                                            <option value='' disabled>Modal</option>
                                            <option value="1">Right Handed</option>
                                            <option value="2">Left Handed</option>
                                        </select>
                                        <Form.Control.Feedback type="invalid">
                                            Please select a Dexterity
                                        </Form.Control.Feedback>
                                    </div>
                                </div>
                            </div>
                        </Tab>
                    )
                        : (
                            <Tab eventKey="result" title="Results">
                                {/* <div className="build_number_box history-tab-box">
                                    <div className="build_number_box_inner">
                                        <div className="left_box_content">
                                            <div className="fitting_name">
                                                Fitting: <br /> <span>{formData?.fitter_name || "No Fitter"}</span>
                                            </div>
                                        </div>
                                        <div className="right_box_content">
                                            <div className="box_btn">
                                                <Link to={`/project/clubfitting/clubfitting-view/${formData?._id}`}>
                                                    <button className="btn-colr-view">View</button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                {
                                    prescription &&
                                    <div className="build_number_box history-tab-box">
                                        <div className="build_number_box_inner">
                                            <div className="left_box_content">
                                                <div className="fitting_name">
                                                    Prescription: <br /> <span>{prescription.fitter || "No Fitter"}</span>
                                                </div>
                                            </div>
                                            <div className="right_box_content">
                                                <div className="box_btn">
                                                    <Link to={`/project/prescription/prescription-view/${prescription.project_id}`}>
                                                        <button className="btn-colr-view">View</button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {
                                    buildsheetData &&
                                    <div className="build_number_box history-tab-box">
                                        <div className="build_number_box_inner">
                                            <div className="left_box_content">
                                                <div className="fitting_name">
                                                    Build Sheet: <br /> <span>{buildsheetData.customer || "No Fitter"}</span>
                                                </div>
                                            </div>
                                            <div className="right_box_content">
                                                <div className="box_btn">
                                                    <Link to={`/project/buildsheet/buildsheet-view/${buildsheetData.project_id}`}>
                                                        <button className="btn-colr-view">View</button>
                                                    </Link>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                } */}
                                <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0" className="results-accordion">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5>
                                                                <span className="color"></span>
                                                                <div className="d-flex align-items-center gap-1">Bounce: <div className="light-text">{resultoutput.white.label}</div></div>
                                                            </h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="results-accordion-body">
                                                <div className="irons-content">
                                                    <div className="result-club">
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.white.bestposition === 1 ? 'active' : ''}`}>White 1 <br /><span class="result-value">{resultoutput.white.iron1}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item middle-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.white.bestposition === 2 ? 'active' : ''}`}>White 2 <br /><span class="result-value">{resultoutput.white.iron2}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.white.bestposition === 3 ? 'active' : ''}`}>White 3 <br /><span class="result-value">{resultoutput.white.iron3}</span></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1" className="results-accordion black">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5>
                                                                <span className="color"></span>
                                                                <div className="d-flex align-items-center gap-1">Lie Angle:  <div className="light-text">{resultoutput.black.label}</div></div>
                                                            </h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="results-accordion-body">
                                                <div className="irons-content">
                                                    <div className="result-club">
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.black.bestposition === 1 ? 'active' : ''}`}>Black 1 <br /><span class="result-value">{resultoutput.black.iron1}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item middle-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.black.bestposition === 2 ? 'active' : ''}`}>Black 2 <br /><span class="result-value">{resultoutput.black.iron2}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.black.bestposition === 3 ? 'active' : ''}`}>Black 3 <br /><span class="result-value">{resultoutput.black.iron3}</span></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="2" className="results-accordion blue">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5>
                                                                <span className="color"></span>
                                                                <div className="d-flex align-items-center gap-1">Shaft Weight: <div className="light-text">{resultoutput.blue.label}</div></div>
                                                            </h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="results-accordion-body">
                                                <div className="irons-content">
                                                    <div className="result-club">
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.blue.bestposition === 1 ? 'active' : ''}`}>Blue 1 <br /><span class="result-value">{resultoutput.blue.iron1}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item middle-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.blue.bestposition === 2 ? 'active' : ''}`}>Blue 2 <br /><span class="result-value">{resultoutput.blue.iron2}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.blue.bestposition === 3 ? 'active' : ''}`}>Blue 3 <br /><span class="result-value">{resultoutput.blue.iron3}</span></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="3" className="results-accordion pink">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5>
                                                                <span className="color"></span>
                                                                <div className="d-flex align-items-center gap-1">Shaft Flex:  <div className="light-text">{resultoutput.pink.label}</div></div>
                                                            </h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="results-accordion-body">
                                                <div className="irons-content">
                                                    <div className="result-club">
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.pink.bestposition === 1 ? 'active' : ''}`}>Pink 1 <br /><span class="result-value">{resultoutput.pink.iron1}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item middle-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.pink.bestposition === 2 ? 'active' : ''}`}>Pink 2 <br /><span class="result-value">{resultoutput.pink.iron2}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.pink.bestposition === 3 ? 'active' : ''}`}>Pink 3 <br /><span class="result-value">{resultoutput.pink.iron3}</span></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="4" className="results-accordion purple">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5>
                                                                <span className="color"></span>
                                                                <div className="d-flex align-items-center gap-1">Shaft Profile:  <div className="light-text">{resultoutput.purple.label}</div></div>
                                                            </h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="results-accordion-body">
                                                <div className="irons-content">
                                                    <div className="result-club">
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.purple.bestposition === 1 ? 'active' : ''}`}>Purple 1 <br /><span class="result-value">{resultoutput.purple.iron1}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item middle-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.purple.bestposition === 2 ? 'active' : ''}`}>Purple 2 <br /><span class="result-value">{resultoutput.purple.iron2}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.purple.bestposition === 3 ? 'active' : ''}`}>Purple 3 <br /><span class="result-value">{resultoutput.purple.iron3}</span></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="5" className="results-accordion red">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5>
                                                                <span className="color"></span>
                                                                <div className="d-flex align-items-center gap-1">Grip Size:  <div className="light-text">{resultoutput.red.label}</div></div>
                                                            </h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="results-accordion-body">
                                                <div className="irons-content">
                                                    <div className="result-club">
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.red.bestposition === 1 ? 'active' : ''}`}>Red 1 <br /><span class="result-value">{resultoutput.red.iron1}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item middle-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.red.bestposition === 2 ? 'active' : ''}`}>Red 2 <br /><span class="result-value">{resultoutput.red.iron2}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.red.bestposition === 3 ? 'active' : ''}`}>Red 3 <br /><span class="result-value">{resultoutput.red.iron3}</span></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="6" className="results-accordion orange">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5>
                                                                <span className="color"></span>
                                                                <div className="d-flex align-items-center gap-1">Club Length:  <div className="light-text">{resultoutput.orange.label}</div></div>
                                                            </h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="results-accordion-body">
                                                <div className="irons-content">
                                                    <div className="result-club">
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.orange.bestposition === 1 ? 'active' : ''}`}>Orange 1 <br /><span class="result-value">{resultoutput.orange.iron1}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item middle-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.orange.bestposition === 2 ? 'active' : ''}`}>Orange 2 <br /><span class="result-value">{resultoutput.orange.iron2}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.orange.bestposition === 3 ? 'active' : ''}`}>Orange 3 <br /><span class="result-value">{resultoutput.orange.iron3}</span></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="7" className="results-accordion green">
                                        <div className="gs_b p-0 club-fitting-card  accordion-item">
                                            <div className="accordion_card_view" id="lesson_card_1">
                                                <Accordion.Header>
                                                    <div className="gab_title">
                                                        <div className="gab_text text-left">
                                                            <h5>
                                                                <span className="color"></span>
                                                                <div className="d-flex align-items-center gap-1">Swing Weight:  <div className="light-text">{resultoutput.green.label}</div></div>
                                                            </h5>
                                                        </div>
                                                        <div className="collapsed">
                                                            <div className="gab_icon ">
                                                                <FaAngleUp />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                            </div>
                                            <Accordion.Body className="results-accordion-body">
                                                <div className="irons-content">
                                                    <div className="result-club">
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.green.bestposition === 1 ? 'active' : ''}`}>Green 1 <br /><span class="result-value">{resultoutput.green.iron1}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item middle-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.green.bestposition === 2 ? 'active' : ''}`}>Green 2 <br /><span class="result-value">{resultoutput.green.iron2}</span></span>
                                                            </div>
                                                        </div>
                                                        <div className="result-club-item">
                                                            <div className="result-club-text">
                                                                <span className={`result-title ${resultoutput.green.bestposition === 3 ? 'active' : ''}`}>Green 3 <br /><span class="result-value">{resultoutput.green.iron3}</span></span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Accordion.Body>
                                        </div>
                                    </Accordion.Item>
                                </Accordion>
                            </Tab>
                        )
                    }

                    <Tab eventKey="client" title="Client">
                        <div className="tab-box-section">
                            <TabFormData project_id={project_id} remortFittingFormData={remortFittingFormData}/>
                        </div>
                    </Tab>

                    <Tab eventKey="notes" title="Notes">
                        <TabNotesData project_id={project_id} />
                    </Tab>
                </Tabs>
            </div>
        </>
    );
}

export default BuildTabPrescription;